module.exports = __webpack_public_path__ + "static/media/styledClose.6776a2a2.svg";